import React from 'react';

import { AuthProvider } from './auth';
import { ToastProvider } from './toast';
import { UserIdProvider } from './user';

const AppProvider: React.FC = ({ children }) => (
  <AuthProvider>
    <ToastProvider>
      <UserIdProvider>{children}</UserIdProvider>
    </ToastProvider>
  </AuthProvider>
);

export default AppProvider;
